import PageStructure, { PageContent, PageContentHeader, PageContentInner, Pane, PaneContent } from "@pages/PageStructure.component";
import { useState } from "react";
import { DraftOnly } from "@components/project/DraftModeRequired.component";
import PipelineNodeList from "@components/pipelineNodes/PipelineNodeList.component";
import { getGroupValueForNodeType } from "@services/modeling.service";
import NewCleaningStepModal from "@components/pipelineNodes/modal/NewCleaningStepModal.component";


const CleaningListPage = () => {
    const [search, setSearch] = useState('');
    const [showNewCleaningStepModal, setShowNewCleaningStepModal] = useState(false);
    const [selectedCleaningStepType, setSelectedCleaningStepType] = useState('NEW');
    const [selectedGroupingBehavior, setSelectedGroupingBehavior] = useState('STACK');

    return <PageStructure>
    <NewCleaningStepModal
        show={showNewCleaningStepModal}
        onHide={() => setShowNewCleaningStepModal(false)}
    />
    <PageContent>
        <PageContentHeader>
            <div className="d-flex center-vertically">
                <div style={{width:'40%'}}>
                    <h1 className="mb-0">Cleaning</h1>
                    <div className="text-muted font-13">Clean, format, and deduplicate your source data before connecting it to your data model.</div>
                </div>
                <div className="flex-1 ps-5 pe-5">
                    <input type="text" className="form-control input-rounded input-search" placeholder="Search..." value={search} onChange={e => setSearch(e.target.value)}/>

                </div>
                <div>
                    <DraftOnly>
                        <button className="btn btn-outline-primary" onClick={() => {
                            setSelectedCleaningStepType('WIZARD');
                            setSelectedGroupingBehavior('STACK');
                            setShowNewCleaningStepModal(true);
                        }}>
                            <i className="mdi mdi-plus-thick"></i> New Cleaning Step
                        </button>
                    </DraftOnly>
                </div>
            </div>
        </PageContentHeader>
        <PageContentInner hasHeader>
            <Pane>
                <PaneContent>
                    <div className="p-4">
                        <PipelineNodeList
                            headerIcon="mdi mdi-broom"
                            headerIconColor="dark"
                            title="Basic Cleaning"
                            actionButtonText="Add New"
                            actionButtonIcon="mdi mdi-plus-thick"
                            actionButtonOnClick={() => {
                                setSelectedGroupingBehavior('STACK');
                                setSelectedCleaningStepType('WIZARD');
                                setShowNewCleaningStepModal(true);
                            }}
                            searchQuery={search}
                            nodeFilter={(node) => node.node_type == 'STAGING' && node.grouping_behavior == 'STACK'}
                            headerChildren={<div className="text-muted font-13">Clean and format your source data without grouping.</div>}
                        />
                        <PipelineNodeList
                            headerIcon="mdi mdi-set-merge"
                            headerIconColor="dark"
                            title="Merge"
                            actionButtonText="Add New"
                            actionButtonIcon="mdi mdi-plus-thick"
                            actionButtonOnClick={() => {
                                setSelectedGroupingBehavior('MERGE');
                                setSelectedCleaningStepType('WIZARD');
                                setShowNewCleaningStepModal(true);
                            }}
                            searchQuery={search}
                            nodeFilter={(node) => getGroupValueForNodeType(node.node_type) == 'STAGING' && node.grouping_behavior == 'MERGE'}
                            headerChildren={<div className="text-muted font-13">Merge records from multiple upstream data sources.</div>}
                        />
                        <PipelineNodeList
                            headerIcon="mdi mdi-filter"
                            headerIconColor="dark"
                            title="Deduplicate"
                            actionButtonText="Add New"
                            actionButtonIcon="mdi mdi-plus-thick"
                            actionButtonOnClick={() => {
                                setSelectedGroupingBehavior('DEDUPLICATE');
                                setSelectedCleaningStepType('WIZARD');
                                setShowNewCleaningStepModal(true);
                            }}
                            searchQuery={search}
                            nodeFilter={(node) => getGroupValueForNodeType(node.node_type) == 'STAGING' && node.grouping_behavior == 'DEDUPLICATE'}
                            headerChildren={<div className="text-muted font-13">Remove duplicate records from an upstream data source.</div>}
                        />
                        <PipelineNodeList
                            headerIcon="mdi mdi-select-group"
                            headerIconColor="dark"
                            title="Aggregate"
                            actionButtonText="Add New"
                            actionButtonIcon="mdi mdi-plus-thick"
                            actionButtonOnClick={() => {
                                setSelectedGroupingBehavior('SUMMARIZE');
                                setSelectedCleaningStepType('WIZARD');
                                setShowNewCleaningStepModal(true);
                            }}
                            searchQuery={search}
                            nodeFilter={(node) => getGroupValueForNodeType(node.node_type) == 'STAGING' && node.grouping_behavior == 'SUMMARIZE'}
                            headerChildren={<div className="text-muted font-13">Create an aggregated table from an upstream data source.</div>}
                        />
                        <PipelineNodeList
                            headerIcon="mdi mdi-card-account-details"
                            headerIconColor="dark"
                            title="Identify"
                            actionButtonText="Add New"
                            actionButtonIcon="mdi mdi-plus-thick"
                            actionButtonOnClick={() => {
                                setSelectedGroupingBehavior('IDENTIFY');
                                setSelectedCleaningStepType('WIZARD');
                                setShowNewCleaningStepModal(true);
                            }}
                            searchQuery={search}
                            nodeFilter={(node) => getGroupValueForNodeType(node.node_type) == 'STAGING' && node.grouping_behavior == 'IDENTIFY'}
                            headerChildren={<div className="text-muted font-13">Identify records that share common attributes.</div>}
                        />
                        <PipelineNodeList
                            headerIcon="mdi mdi-set-split"
                            headerIconColor="dark"
                            title="Split"
                            actionButtonText="Add New"
                            actionButtonIcon="mdi mdi-plus-thick"
                            actionButtonOnClick={() => {
                                setSelectedCleaningStepType('SPLIT');
                                setShowNewCleaningStepModal(true);
                            }}
                            searchQuery={search}
                            nodeFilter={(node) => node.node_type == 'SPLIT'}
                            headerChildren={<div className="text-muted font-13">Split records into multiple rows based on a delimiter or JSON array.</div>}
                        />
                        <PipelineNodeList
                            headerIcon="mdi mdi-code-braces"
                            headerIconColor="dark"
                            title="Custom DBT Models"
                            actionButtonText="Add New"
                            actionButtonIcon="mdi mdi-plus-thick"
                            actionButtonOnClick={() => {
                                setSelectedCleaningStepType('CUSTOM');
                                setShowNewCleaningStepModal(true);
                            }}
                            searchQuery={search}
                            nodeFilter={(node) => node.node_type == 'CUSTOM'}
                        />

                    </div>
                </PaneContent>
            </Pane>
        </PageContentInner>
        
    </PageContent>
</PageStructure>
}


export default CleaningListPage;